
import { useUserStore } from "@/store";
import { defineComponent } from "vue";
import { useRouter } from "vue-router";
export default defineComponent({
  name: "avatar",
  setup() {
    const userStore = useUserStore();
    const userEmail = userStore.getEmail;
    const router = useRouter();

    //logout
    const handleLogout = () => {
      userStore.logout();
      router.push("/login");
    };
    const handleGotoProfile = () => {
      router.push("/user/profile");
    };
    return {
      userEmail,
      handleLogout,
      handleGotoProfile,
    };
  },
});
